import axios from "axios";
import api from "services/api";
import type {
  BaixaTituloPayloadPagar,
  BaixaTituloPayloadReceber,
  BaixaTituloResponse,
} from "../types/baixa-titulo.types";

function erroAxios(e: unknown): string {
  if (axios.isAxiosError(e)) {
    const data = e.response?.data as { error?: string } | undefined;
    if (data?.error && typeof data.error === "string") return data.error;
    if (e.response?.status === 403) return "Sem permissão para baixar títulos.";
    return e.message || "Falha na requisição.";
  }
  return e instanceof Error ? e.message : "Falha na requisição.";
}

export async function baixarTituloReceber(
  id: string,
  payload: BaixaTituloPayloadReceber,
): Promise<{ data: BaixaTituloResponse | null; status: number; error?: string }> {
  try {
    const res = await api.post<BaixaTituloResponse>(
      `/loja/financeiro/titulos-receber/${encodeURIComponent(id)}/baixar`,
      payload,
    );
    return { data: res.data ?? null, status: res.status };
  } catch (e: unknown) {
    return {
      data: null,
      status: axios.isAxiosError(e) ? e.response?.status ?? 0 : 0,
      error: erroAxios(e),
    };
  }
}

export async function baixarTituloPagar(
  id: string,
  payload: BaixaTituloPayloadPagar,
): Promise<{ data: BaixaTituloResponse | null; status: number; error?: string }> {
  try {
    const res = await api.post<BaixaTituloResponse>(
      `/loja/financeiro/titulos-pagar/${encodeURIComponent(id)}/baixar`,
      payload,
    );
    return { data: res.data ?? null, status: res.status };
  } catch (e: unknown) {
    return {
      data: null,
      status: axios.isAxiosError(e) ? e.response?.status ?? 0 : 0,
      error: erroAxios(e),
    };
  }
}
